(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["email-signup"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function() {
    const form = document.getElementById('phone-form-{{ block.id }}');
    const phoneInput = document.getElementById('PhoneInput-{{ block.id }}');
    
    if (form && phoneInput) {
      // Format phone number as user types (add dash after 3rd digit)
      phoneInput.addEventListener('input', function(e) {
        let value = e.target.value.replace(/\D/g, ''); // Remove non-digits
        
        // Add dash after 3rd digit if there are more than 3 digits
        if (value.length > 3) {
          value = value.substring(0, 3) + '-' + value.substring(3);
        }
        
        e.target.value = value;
      });
      
      // Clean phone number before submission
      form.addEventListener('submit', function(e) {
        let phoneValue = phoneInput.value.replace(/\D/g, ''); // Remove all non-digits
        
        // Validate: must be exactly 10 digits and start with 0
        if (phoneValue.length !== 10 || !phoneValue.startsWith('0')) {
          e.preventDefault();
          alert('אנא הזן מספר טלפון תקין (10 ספרות)');
          return false;
        }
        
        // Format with country code for Shopify
        phoneInput.value = '+972' + phoneValue.substring(1);
      });
    }
  });
  } catch(e) { console.error(e); }
})();

})();
